import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../_services/account.service';
import { ModalRegisterPendingComponent } from '../modal-register-pending/modal-register-pending.component';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})
export class ResetPassComponent implements OnInit {
  form: FormGroup;
  submitted = false;  
  errorService = false;
  errorMsg = '';
  token='';

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private formBuilder: FormBuilder,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.token=this.router.url.split('=')[1]; 
    this.form = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required,Validators.minLength(6)])],
      confirmPassword: ['', Validators.required],
    }, { validators: this.ConfirmedValidator('password', 'confirmPassword') });
  }

  ConfirmedValidator(controlName: string, matchingControlName: string){
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        /*if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
            return;
        }*/
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ confirmedValidator: true });
        } 
    }   
  }

  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    this.errorService = false;

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }

    this.accountService.resetPassword(this.token, this.f.password.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        const modalRef = this.modalService.open(ModalRegisterPendingComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.padre = 'login';
        if(response.msg === "CHANGE_PASSWORD_SUCCESS") {
          modalRef.componentInstance.titulo = 'Contraseña cambiada';
          modalRef.componentInstance.texto = 'Su contraseña ha sido cambiada. Puede iniciar sesión en el sistema.';                              
          modalRef.componentInstance.check = 'ok';
        } else {
          if(response.msg === "TOKEN_INVALID" || response.msg === "USER_NOT_FOUND") {
            modalRef.componentInstance.titulo = 'Operación fallida';
            modalRef.componentInstance.texto = 'Los sentimos, el token ha caducado. Solicite nuevamente un enlace de restauración';
            modalRef.componentInstance.check = 'error';
          }
          if (response.msg === undefined) {
            modalRef.componentInstance.titulo = 'Operación fallida';
            modalRef.componentInstance.texto = 'Problemas con el servidor. Contacte al administrador';
            modalRef.componentInstance.check = 'error';
          }
          //this.submitted = false;
          //this.form.reset();
        }
      }
    });
            
  } 

}
